export const equipment = (state) => state.equipment
export const brands = (state) => state.brands
export const models = (state) => state.models
export const model = (state) => state.model
export const statusRequest = (state) => state.statusRequest
